/**
 * @access protected
 */
export class Service {
    constructor({ $publish }) {
        this.$publish = $publish;
    }
}
//# sourceMappingURL=Service.js.map